import React from 'react'
import {Link} from 'react-router-dom'
function Error() {
  return (
    <div className='flex flex-col gap-3 justify-center items-center'>
      <h1 className='text-center text-[8rem] font-bold tracking-wider text-[#9499ff] mt-28 xl:text-[9rem]'>404</h1>
      <h2 className='text-[#E3E3E3] dark:text-[#1E1E1E] text-2xl font-bold xl:text-3xl'>Opps! page not found</h2>
      <p className='text-[#E3E3E3] dark:text-[#1E1E1E] text-xl mt-3'>Sorry, the page you're looking for doesn't exist.</p>
      <button className='btn mt-8'><Link to='/'>Return Home</Link></button>

    </div>
  )
}

export default Error